// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__vmOnB","label":"styles_label__kYnt0","skeleton-animation":"styles_skeleton-animation__grSMs"};